const sourceBandMap: Record<string, { band: string; bandName: string }> = {
  adspend: { band: 'adspend', bandName: '广告花费告警' },
  revenue_reconcile: { band: 'revenue_reconcile', bandName: '收入对账告警' }
};

/** Normalize source-specific fields omitted by non-metric-trend alerts. */
export function normalizeMetricAlerts(alerts: Api.Auth.MetricsAlert[]) {
  return alerts.map(alert => {
    const sourceBand = alert.source ? sourceBandMap[alert.source] : undefined;
    if (!sourceBand) return alert;

    return {
      ...alert,
      ...sourceBand,
      metric: '-',
      metricName: '-'
    };
  });
}
